import React, { useCallback, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { isEmpty } from 'ramda';

// store
import { storeSet, useStoreValue } from '../../../../../../store';

// components
import SwitchButton from '../../../../../../components/SwitchButton';
import KnobField from '../../../../../../components/KnobField';
import SliderField from '../../../../../../components/SliderField';
import SlideUpIcon from '../../../../../../icons/SlideUpIcon';

const SlidingDeck = () => {
    const timelineVolume = useStoreValue('timelineVolume');
    const trackMusicVolume = useStoreValue('trackMusicVolume');
    const trackSfxVolume = useStoreValue('trackSfxVolume');
    const trackDialogueVolume = useStoreValue('trackDialogueVolume');
    const trackMusicMuted = useStoreValue('trackMusicMuted');
    const trackSfxMuted = useStoreValue('trackSfxMuted');
    const trackDialogueMuted = useStoreValue('trackDialogueMuted');
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const timelineEditorUiCollapsed = useStoreValue('timelineEditorUiCollapsed');
    const timelineRefMode = useStoreValue('timelineRefMode');
    const [isShownSlidingDeckState, setIsShownSlidingDeckState] = useState(false);

    const handleVolumeChange = (value, storeKey) => {
        storeSet(storeKey, value);
    };

    const handleMuteToggle = (trackType) => {
        const muteKey = `track${trackType.charAt(0).toUpperCase() + trackType.slice(1)}Muted`;
        let currentMuteState;
        if (trackType === 'music') currentMuteState = trackMusicMuted;
        else if (trackType === 'sfx') currentMuteState = trackSfxMuted;
        else if (trackType === 'dialogue') currentMuteState = trackDialogueMuted;

        storeSet(muteKey, !currentMuteState);
    };

    const handleMultiMode = useCallback(() => {
        storeSet('timelineEditorUiCollapsed', timelineEditorUiCollapsed !== true)
    }, [timelineEditorUiCollapsed]);

    return (
        <div
            className={`timelineEditorSlidingDeck ${!isEmpty(myStudioLeftPanel) ? 'compact' : ''} ${isShownSlidingDeckState ? 'expanded' : 'collapsed'}`}>
            {!isEmpty(myStudioLeftPanel)
                ? <button
                    className={['timelineEditorSlidingDeck__toggle', (isShownSlidingDeckState ? 'expanded' : 'collapsed')].join(' ')}
                    onClick={() => setIsShownSlidingDeckState(prev => !prev)}>
                    <SlideUpIcon/>
                </button> : null}
            <div className={`timelineEditorAuxControls__knob ${!isEmpty(myStudioLeftPanel) ? 'compact' : ''}`}>
                <div>
                    <SwitchButton
                        variant="ref"
                        checked={timelineEditorUiCollapsed}
                        changeFn={handleMultiMode}
                        tooltip="Refe variant"
                    />
                    <label className="controlLabel">{__('Multi', 'soundbetween')}</label>
                </div>
                <div>
                    <KnobField
                        size={isEmpty(myStudioLeftPanel) ? 'lg' : 'md'}
                        class="generalVolume"
                        value={timelineVolume}
                        name="timelineVolume"
                        min={0}
                        max={100}
                        changeFn={handleVolumeChange}
                    />
                    <label className="controlLabel">{__('Level', 'soundbetween')}</label>
                </div>
                <div>
                    <SwitchButton
                        variant="default"
                        checked={timelineRefMode}
                        changeFn={() => storeSet('timelineRefMode', !timelineRefMode)}
                        tooltip={__('Toggle music/reference')}
                    />
                    <label className="controlLabel">{__('Ref/St', 'soundbetween')}</label>
                </div>
            </div>
            <div className="timelineEditorAuxControls__slides">
                <div>
                    <SliderField
                        value={trackMusicVolume}
                        min={0}
                        max={100}
                        name="trackMusicVolume"
                        step={2}
                        changeFn={handleVolumeChange}
                    />
                </div>
                <div>
                    <SliderField
                        value={trackSfxVolume}
                        min={0}
                        max={100}
                        name="trackSfxVolume"
                        step={2}
                        changeFn={handleVolumeChange}
                    />
                </div>
                <div>
                    <SliderField
                        value={trackDialogueVolume}
                        min={0}
                        max={100}
                        name="trackDialogueVolume"
                        step={2}
                        changeFn={handleVolumeChange}
                    />
                </div>
                <div>
                    <SwitchButton
                        variant="music"
                        checked={!trackMusicMuted}
                        changeFn={() => handleMuteToggle('music')}
                        tooltip={__('Mute music', 'soundbetween')}
                    />
                </div>
                <div>
                    <SwitchButton
                        variant="sfx"
                        checked={!trackSfxMuted}
                        changeFn={() => handleMuteToggle('sfx')}
                        tooltip={__('Mute sfx', 'soundbetween')}
                    />
                </div>
                <div>
                    <SwitchButton
                        variant="dialogue"
                        checked={!trackDialogueMuted}
                        changeFn={() => handleMuteToggle('dialogue')}
                        tooltip={__('Mute dialogue', 'soundbetween')}
                    />
                </div>
                <div><label>{__('Mus', 'soundbetween')}</label></div>
                <div><label>{__('Sfx', 'soundbetween')}</label></div>
                <div><label>{__('Dlg', 'soundbetween')}</label></div>
            </div>
        </div>
    );
};

export default SlidingDeck;
